// src/components/ErrorBoundary.js
import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard/home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '50px 20px', textAlign: 'center' }}>
          <Result
            status="500"
            title="Something went wrong"
            subTitle={this.state.error?.message || 'An unexpected error occurred. Please try again.'}
            extra={
              <Button type="primary" onClick={this.handleReset} size="large">
                Go to Dashboard
              </Button>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
